import React from "react";
import { withRouter } from "next/router";
import Layout from '../layouts/SiteLayout';
import SiteLoader from '../components/SiteLoader';
import validator from '../actions/validation';
import AuthAction from '../services/auth';
import mailer from '../actions/mail';
import AuthCheck from '../actions/authCheck';
import map from 'lodash/map';
import intersection from 'lodash/intersection';
import { success, error } from "../components/Toast";
import { MdArrowForward } from '@react-icons/all-files/md/MdArrowForward';
import { MdRemoveRedEye } from '@react-icons/all-files/md/MdRemoveRedEye';
import SlackWebHook from "../actions/slack";
import BgOrgHead from '../components/custom/svg/bgOrgHead'

class ForgetPass extends React.Component {

  static getInitialProps({query, pathname, asPath}) {
    return {query, pathname, asPath};
  }

  constructor (props) {
    super(props);
    this.state = {
      formInput: {
        email: '',
        newPass: '',
        rePass: ''
      },
      validationTest: false,
      siteLoading: true,
      submitLoading: false
    };
  }

  componentDidMount() {
    if (!AuthCheck.checkCookie()) {
      this.setState({
        ...this.state,
        siteLoading: false
      })
    }else{
      const role = AuthCheck.checkAuth(Cookie.getCookie('_accessToken'));
      role.roles = map(Object.values(JSON.parse(role.roleDetails)), 'roleMachineName').join(',');
      if (intersection(['agent'], role.roles.split(',')).length > 0) {
        this.props.router.push('/agent');
      } else {
        this.props.router.push('/students');
      }
    }
  }

  /***
   *
   * handleSendMail will fire when Send Reset Link button will be clicked
   * This function will check whether the user email is exists or not and valid email or not
   * If valid then then send the email with the verify link
   *
   * Author; Susanta Chakraborty
   * Date: 23rd oct,2019
   *
   * @param: event
   * @return:
   *
   */
  handleForgetPass = (e) => {
    const parentThis = this;
    e.preventDefault();
    this.setState({
      ...this.state,
      validationTest: true,
      submitLoading: true
    }, () => {
      if (validator.email(this.state.formInput.email.trim())) {
        AuthAction.forgetPasswordUser(this.state.formInput.email)
          .then(res => {
            const response = res.data.forgetPasswordUser;
            console.log(response);

            if (response.code === '200' && response.status === 'success') {
              let token = response.data.user.token;
              this.sendMail(token, this.state.formInput.email);
            } else {
              this.setState({...this.state, submitLoading: false}, () => {
                this.clearFormValue();
                error(response.message);
              });
            }

          }).catch(function (err) {
          parentThis.setState({ submitLoading: false });
          parentThis.clearFormValue();
          SlackWebHook.sendSlackMessage('forgetPass','handleForgetPass',`${err.message}`)
        });

      }else{
        this.setState({...this.state, submitLoading: false}, () => {
          this.clearFormValue();
          error("It's not a valid Email");
        });
      }
    });
  }

  /***
   *
   * sendMail is used to send the token and Verify
   * link to the user email address
   *
   * Author; Susanta Chakraborty
   * Date: 23rd oct,2019
   *
   * @param: token
   * @return:
   *
   */
  sendMail = (token, email) => {
    const parentThis = this;
    const to = parentThis.state.formInput.email;
    const mailType = 'forgetPassword-mail';
    const cc = [];
    const bcc = [];
    const subject = 'Please verify the mail.';
    let data = {
      verificationLink: window.location.origin + '/forget-pass?cql=' + token + '&email=' + btoa(email),
      actionUrl: process.env.NEXT_PUBLIC_APP_URI
    };

    mailer.sendMail(to, mailType, cc, bcc, subject, false, data).then(res => {
      if (res.status === 'success' && res.code === '250') {
        success('Reset Link sent to your inbox.');
        this.setState({
          ...this.state,
          formInput: {
            ...this.state.formInput,
            email: ''
          },
          submitLoading: false,
          validationTest: false
        });
      } else {
        error(res.message);
      }
    }).catch(error => {
      error('Something went wrong.');
      parentThis.setState({ ...parentThis.state, submitLoading: false });
      SlackWebHook.sendSlackMessage('forgetPass','sendMail',`${error.message}`)
    });
  }
  /***
   * handleResetPass will fire when Reset your Password button will be clicked
   * This function will check whether the new password is week or not and confirm pass is
   * same and then update the password and redirect to the login page
   *
   * Author; Susanta Chakraborty
   * Date: 23rd oct,2019
   *
   * @param: token, event
   * @return:
   *
   */
  handleResetPass = (e) => {
    const parentThis = this;
    e.preventDefault();
    this.setState({
      ...this.state,
      validationTest: true,
      submitLoading: true
    }, () => {
      if (validator.passwordStrength(this.state.formInput.newPass, 'week') &&
        validator.passwordStrength(this.state.formInput.rePass, 'week') &&
        this.state.formInput.newPass === this.state.formInput.rePass) {
        const token = this.props.query.cql;
        const email = this.props.query.email;
        console.log(token);
        AuthAction.resetPasswordUser(token, this.state.formInput.newPass)
          .then(res => {
            const response = res.data.resetPasswordUser;
            console.log(response);
            if (response.code === '200' && response.status === 'success') {
              this.setState({ ...this.state, submitLoading: false }, () => {
                success(response.message);
                //mail
                const data = {
                  "actionUrl":`${process.env.NEXT_PUBLIC_APP_URI}`
                }
                mailer.sendMail(atob(email), 'resetPasswordSuccessfull-mail', [], [], `Your New ${process.env.NEXT_PUBLIC_BRAND_NAME} Password`, false, data)
                setTimeout(function () {
                  this.props.router.push('/');
                }, 3000);
              })
            } else {
              this.setState({...this.state, submitLoading: false}, () => {
                this.clearFormValue();
                error(response.message);
              });
            }

          }).catch(function (err) {
          parentThis.setState({ submitLoading: false });
          parentThis.clearFormValue();
          SlackWebHook.sendSlackMessage('forgetPass','handelResetPass',`${err.message}`)
        })

      }else{
        this.setState({...this.state, submitLoading: false}, () => {
          this.clearFormValue();
          error("Missing Required Fields");
        });
      }
    });
  }
  /***
   *
   * getFormValue is used to get value from
   * while typing individual key
   * and set it to state for farther use
   *
   * Author; Susanta Chakraborty
   * Date: 22nd oct,2019
   *
   * @param: event
   * @return:
   *
   */
  getFormValue = (e) => {
    this.setState({
      ...this.state,
      formInput: {
        ...this.state.formInput,
        [e.target.name] : e.target.value
      },
      validationTest: false
    })
  }
  /***
   *
   * clearFormValue is used to clear value from state
   * and set the state to blank
   *
   * Author; Susanta Chakraborty
   * Date: 23rd oct,2019
   *
   * @param:
   * @return:
   *
   */
  clearFormValue = () => {
    this.setState({
      ...this.state,
      formInput: {
        ...this.state.formInput,
        rePass: ''
      }
    });
  }

  passwordToggle = () => {
    const input = document.getElementById('reset-password');
    const unmaskBtn = document.getElementById('unmask');
    if(input.type === 'password') {
      input.type = 'text';
      unmaskBtn.classList.add('active');
    } else {
      input.type = 'password';
      unmaskBtn.classList.remove('active');
    }
  }

  render() {
    const { validationTest, siteLoading, submitLoading } = this.state;
    const { email, newPass, rePass } = this.state.formInput;

    return (
      <Layout>
        {
          siteLoading &&
          <SiteLoader/>
        }
        <div className="login-wrapper d-flex justify-content-start align-items-start">
          <div className="img-left--wrapper">
            <BgOrgHead className='desktop-only'/>
            <BgOrgHead className='mobile-only'/>

          </div>
          { this.props.query.cql === '' || this.props.query.cql === undefined || this.props.query.cql === null ?
            <section className="login-default--wrapper">
              <div className="signin-as-text txt-32--title">
                Forgot Password
              </div>
              <h5 className="sample-line">Don't have an account yet? <a href="/signup" >Get an account.</a></h5>
              <form className="form-login--wrapper" method="post">
                <div className="form-group mb-4">
                  <label htmlFor="email" className="col-form-label">Email</label>
                  <input
                    type="text"
                    onChange={this.getFormValue.bind(this)}
                    placeholder="Enter Your registered E-mail"
                    className={`form-control ${(validationTest && (validator.email(email) ? '' : ' error')).toString()}`}
                    name="email"
                    value={email}
                  />
                </div>
                {/* <a href="/" className="forgot-pass">Remember Login ?</a> */}
                <div className="btn-wrapper">
                  <button
                    className="btn-solid-large --primary w-100"
                    disabled={submitLoading}
                    onClick={this.handleForgetPass}
                  >
                    Send Reset Link
                    <div className={`icon-btn--layer ${submitLoading ? 'no-border' : 'primary-border'}`}>
                      {submitLoading ? <div className={`lds-ring`}><div /><div /><div /><div /></div> : <MdArrowForward fontSize="24px" />}
                    </div>
                  </button>
                </div>
              </form>
            </section>
            :
            <section className="login-default--wrapper">
              <div className="signin-as-text txt-32--title">
                Reset Password
              </div>
              <h5 className="sample-line">Don't have an account yet? <a href="/signup" >Get an account.</a></h5>
              <form className="form-login--wrapper" method="post">
                <div className="form-group mb-4">
                  <label htmlFor="newPass" className="col-form-label">New Password</label>
                  <div className="position-relative">
                    <input
                      type="password"
                      onChange={this.getFormValue.bind(this)}
                      placeholder="New Password"
                      className={'form-control password' + (validationTest && (validator.passwordStrength(newPass, 'week') ? '' : ' error')).toString()}
                      name="newPass"
                      id="reset-password"
                      value={newPass}/>
                    <div id="unmask"
                      className="unmask"
                      onClick={this.passwordToggle}
                    ><MdRemoveRedEye fontSize="24px" />
                    </div>
                  </div>
                </div>
                <div className="form-group mb-4">
                  <label htmlFor="newPass" className="col-form-label">Confirm Password</label>
                  <div className="position-relative">
                    <input
                      type="password"
                      onChange={this.getFormValue.bind(this)}
                      placeholder="Confirm Password"
                      className={'form-control password' + (validationTest && (validator.passwordStrength(newPass, 'week') ? '' : ' error')).toString()}
                      name="rePass"
                      value={rePass}/>
                  </div>
                </div>

                {/* <a href="/" className="forgot-pass">Remember Login ?</a> */}
                <div className="btn-wrapper">
                  <button
                    className="btn-solid-large --primary w-100"
                    disabled={submitLoading}
                    onClick={this.handleResetPass}
                  >
                    Reset Your Password
                    <div className={`icon-btn--layer ${submitLoading ? 'no-border' : 'primary-border'}`}>
                      {submitLoading ? <div className={`lds-ring`}><div /><div /><div /><div /></div> : <MdArrowForward fontSize="24px" />}
                    </div>
                  </button>
                </div>
              </form>
            </section>
          }
        </div>
      </Layout>
    )
  }
}

export default withRouter(ForgetPass);
